/**
 * It is possible to drag a track row behind an open modal unless we bail out.
 */
export const isModalOpen = (): boolean =>
	document.getElementById('anw-modal-portal')?.dataset.modal === 'true'
